import get from 'lodash/get'
import set from 'lodash/set'
import unset from 'lodash/unset'

import { Lang } from 'cat-shared/utils'
import { Theme } from 'react-toastify'

const ROOT_KEY = 'cat-app'

const getRootConfig = (): string | null => {
  let value
  try {
    value = window.localStorage.getItem(ROOT_KEY)
  } catch {
    value = null
  }
  return value
}

const getLocalValue = (path: string): object | null => {
  const rootConfig = getRootConfig()
  const currentValue = JSON.parse(rootConfig) || {}
  return get(currentValue, path, null)
}

const setLocalValue = (path: string, value: string): void => {
  const rootConfig = getRootConfig()
  const currentValue = JSON.parse(rootConfig) || {}
  window.localStorage.setItem(ROOT_KEY, JSON.stringify(set(currentValue, path, value)))
}

const removeLocalItem = (path: string): void => {
  const rootConfig = getRootConfig()
  const currentValue = JSON.parse(rootConfig) || {}
  unset(currentValue, path)
  window.localStorage.setItem(ROOT_KEY, JSON.stringify(currentValue))
}

export const setLocalAuthUser = ({
  id,
  token,
  isAdmin,
}: {
  id: string
  token: string
  isAdmin?: boolean
}): void => {
  setLocalValue('authUser.id', id)
  setLocalValue('authUser.token', token)
  if (isAdmin) {
    setLocalValue('authUser.isAdmin', 'true')
  }
}

export const setLocalUserConfig = (id: string, lang?: Lang, theme?: Theme): void => {
  if (lang) {
    setLocalValue(`users.${id}.lang`, lang)
  }
  if (theme) {
    setLocalValue(`users.${id}.theme`, theme)
  }
}

export const removeLocalAuthUser = (): void => {
  removeLocalItem('authUser.token')
  removeLocalItem('authUser.isAdmin')
}

export const getLocalAuthUser = (): {
  id?: string
  token?: string
  isAdmin?: string
} => {
  return getLocalValue('authUser') || {}
}

export const getLocalUserConfig = (id: string): { lang?: Lang; theme?: Theme } => {
  return getLocalValue(`users.${id}`) || {}
}

export const getLocalLastUserConfig = (): { lang?: Lang; theme?: Theme } => {
  const user = getLocalAuthUser()
  return user?.id ? getLocalUserConfig(user.id) : {}
}
